export default {
  watch: {},
};
